import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 15000 });

export const getVideos = (category) =>
  api.get("/videos", { params: category ? { category } : {} }).then((r) => r.data);

export const getGuests = () => api.get("/guests").then((r) => r.data);

export const getLatestVideos = () => api.get("/youtube/latest").then((r) => r.data.videos || []);

export const getLatestAll = () =>
  api.get("/youtube/latest").then((r) => ({ videos: r.data.videos || [], shorts: r.data.shorts || [] }));

export const postContact = (payload) => api.post("/contact", payload).then((r) => r.data);
